module.exports = __webpack_public_path__ + "assets/photos/memories/frame-9--659d78b121089e2569aa06aa11240afb.png";